import { PromotionCode } from "@/types/PromotionCode";
import Storage from "./Storage";

export const PROMOTION_CODE_STORAGE_KEY = "promotionCode241021";

const TWO_DAYS_IN_SECONDS = 60 * 60 * 24 * 2;

export function savePromotionCode(promotionCode: PromotionCode) {
    Storage.save(PROMOTION_CODE_STORAGE_KEY, promotionCode, {
        secondsTillExpiry: TWO_DAYS_IN_SECONDS,
    });
}

export function clearPromotionCode() {
    Storage.remove(PROMOTION_CODE_STORAGE_KEY);
}

export function usePromoCode(): PromotionCode | null {
    return Storage.load<PromotionCode | null>(PROMOTION_CODE_STORAGE_KEY, null);
}
